import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import Markdown from "react-markdown";

function DefaultPageTemplateImageAndTextBody({ data, slug }) {
    return (
        <div key={data.documentId} className="default-page-template-image-and-text-body col-sm-10 col-xs-12">
            <div className="">
                {/*This image happens to be null at the moment on the contact page*/}
                {data.image != null ? <div className="img-header">
                    <img id="why-air-quality-matters" alt="why-air-quality-matters" className="full-width center-align "
                         src={data.image.url}/>
                </div> : null}

                <div className="template-text">
                    <div className="body-text" style={{maxWidth: 'none'}}>
                        <Markdown>{data.mainText.replaceAll('\n','  \n')}</Markdown>
                    </div>
                </div>

                {slug === 'aqi' ?
                    <div style={{marginTop: '-50px', marginBottom: '50px'}}>
                        <table align="center" border="1" cellPadding="5" cellSpacing="1" style={{width:'85%'}}>
                            <tbody>
                            <tr>
                                <td style={{backgroundColor:'rgb(187, 187, 187)', width:'31.6%'}}>
                                    {/*<p>*/}
                                        <strong>
                                            <span style={{ fontSize:'10.0pt'}}>
                                                Air Quality Index
                                                <br/>
                                                {/*color:'white',*/}
			                                    Levels of Health Concern
                                            </span>
                                        </strong>
                                    {/*</p>*/}
                                </td>
                                <td style={{backgroundColor:'rgb(187, 187, 187)'}}>
                                    {/*<p>*/}
                                        <strong>
                                            <span style={{fontSize:'10.0pt'}}>
                                                {/*color:'white'*/}
                                                Numerical
                                                <br/>
                                                Value
                                            </span>
                                        </strong>
                                    {/*</p>*/}
                                </td>
                                <td style={{backgroundColor:'rgb(187, 187, 187)'}}>
                                    {/*<p>*/}
                                        <strong>
                                            <span style={{fontSize:'10.0pt'}}>
                                                {/*color:'white'*/}
                                                Meaning
                                            </span>
                                        </strong>
                                    {/*</p>*/}
                                </td>
                            </tr>
                            <tr>
                                <td style={{backgroundColor:'rgb(0, 228, 0)', width:'31.6%'}}><span
                                    style={{color:'black', fontSize:'10.0pt'}}>Good</span></td>
                                <td><span style={{color:'black', fontSize:'10.0pt'}}>0-50</span></td>
                                <td><span style={{color:'black', fontSize:'10.0pt'}}>Air quality is considered good, and air pollution poses little or no risk.</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{backgroundColor:'rgb(255, 255, 0)', width:'31.6%'}}><span
                                    style={{color:'black', fontSize:'10.0pt'}}>Moderate</span></td>
                                <td><span style={{color:'black', fontSize:'10.0pt'}}>51-100</span></td>
                                <td><span style={{color:'black', fontSize:'10.0pt'}}>Air quality may pose a moderate health risk, especially for those who are unusually sensitive to air pollution.</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{backgroundColor:'rgb(255, 126, 0)', width:'31.6%'}}><span
                                    style={{color:'black', fontSize:'10.0pt'}}>Unhealthy for<br/>
			Sensitive Groups</span></td>
                                <td><span style={{color:'black', fontSize:'10.0pt'}}>101-150</span></td>
                                <td><span style={{color:'black', fontSize:'10.0pt'}}>Members of sensitive groups, children and adults with respiratory and heart ailments, may experience health effects and should limit time spent outside. The general public is not likely to be affected.</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{backgroundColor:'rgb(255, 0, 0)', width:'31.6%'}}><span
                                    style={{color:'white', fontSize:'10.0pt'}}>Unhealthy </span></td>
                                <td><span style={{color:'black', fontSize:'10.0pt'}}>151-200</span></td>
                                <td><span style={{color:'black', fontSize:'10.0pt'}}>Everyone may experience health effects and should limit their outdoor activity; members of sensitive groups may experience more serious health effects.</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{backgroundColor:'rgb(143, 63, 151)', width:'31.6%'}}><span
                                    style={{color:'white', fontSize:'10.0pt'}}>Very Unhealthy</span></td>
                                <td><span style={{color:'black', fontSize:'10.0pt'}}>201-300</span></td>
                                <td><span style={{color:'black', fontSize:'10.0pt'}}>Everyone may experience more serious health effects and should avoid outdoor activities, especially individuals with heart and breathing ailments, children, and older adults.</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    : null}
            </div>
        </div>
    );
}

export default DefaultPageTemplateImageAndTextBody;
